module.exports = __webpack_public_path__ + "img/tree_swamp.1127cca4.svg";